import React from 'react';
import { Link } from 'wouter';

interface UpgradePromptProps {
  feature: string;
  description?: string;
  className?: string;
}

export default function UpgradePrompt({ feature, description, className = '' }: UpgradePromptProps) {
  const getFeatureDescription = () => {
    switch (feature) {
      case 'scope3':
        return description || 'Track Scope 3 emissions from your value chain including business travel, employee commuting, and supply chain activities.';
      case 'advanced_analytics':
        return description || 'Access advanced analytics, custom reports, and detailed insights to better understand your carbon footprint.';
      case 'priority_support':
        return description || 'Get priority support with faster response times and dedicated assistance.';
      default:
        return description || 'This feature requires a subscription upgrade.';
    }
  };

  const getFeatureTitle = () => {
    switch (feature) {
      case 'scope3':
        return 'Scope 3 Emissions Tracking';
      case 'advanced_analytics':
        return 'Advanced Analytics';
      case 'priority_support':
        return 'Priority Support';
      default:
        return 'Premium Feature';
    }
  };

  return (
    <div className={`bg-gradient-to-r from-green-50 to-blue-50 border border-green-200 rounded-lg p-6 ${className}`}>
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
            <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
        </div>
        
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            {getFeatureTitle()}
          </h3>
          
          <p className="text-gray-600 mb-4">
            {getFeatureDescription()}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              href="/pricing"
              className="inline-flex items-center px-4 py-2 bg-green-600 text-white text-sm font-semibold rounded-lg hover:bg-green-700 transition-colors"
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
              Upgrade Now
            </Link>
            
            <Link
              href="/settings"
              className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 text-sm font-semibold rounded-lg hover:bg-gray-50 transition-colors"
            >
              View Plans
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}













